import React, {useState} from 'react'

import { Header } from '../../components/common/Header';
import { Footer } from '../../components/common/Footer';
import { useAsyncEffect } from '../../helper/hooks/async-hooks';
import { getSelectDate } from '../../components/common/getSelectDate';
import { SelectDate } from '../../components/makeup/SelectDate';
import { FileUp } from '../../components/makeup/FileUp';
import { selectDate, inputInfo } from '../../types/Reievespf002';
import { inputValidate } from '../../components/makeup/inputValidate';
import { ErrorMessage } from '../../components/makeup/ErrorMessage';
import { setAttachmentFile } from '../../components/makeup/setAttachmentFile';
import { setMakeUp } from '../../components/makeup/setMakeUp';
import { getEventJoinId } from '../../components/makeup/getEventJoinId';
import { setMakeUpId } from '../../components/makeup/setMakeUpId';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';

/**
 * メークアップ登録画面
 */
export function Reievespf002 (){
    
    //  メールアドレスを保存するcookie
    const [cookieMail, setCookieMail, removeCookieMail] = useCookies(['address']);
    const loginAddress = cookieMail.address

    //  アカウントIDを保存するcookie
    const [cookieAccId, setCookieAccId, removeCookieAccId] = useCookies(['idCookie']);
    //  対応会員番号を保存するcookie（秘書の場合のみ）
    const [cookieSecAccId, setCookieSecAccId, removeCookieSecAccId] = useCookies(['secIdCookie'])
    //  ロータリーCDを保存するcookie
    const [cookieRotaryCd, setCookieRotaryCd, removeCookieRotaryCd] = useCookies(['rotaryCookie'])


    //  ログイン者のアカウントID
    const loginId = cookieAccId.idCookie;

    //  API呼び出し時のパラメータに設定するアカウントIDを保持するstate
    const [paramId, setParamId] = useState<string>("");

    const navigate = useNavigate();
    
    //  出席にする日付リストを保持するstate
    const [selectDate, setSelectDate] = useState<selectDate[]>([]); 

    //  入力値を保持するstate
    const [input, setInput] = useState({
        selectedDate: "",
        joinedDate: "",
        clubName: "",
        memo: ""
    });

    //  メークアップ証明書を保持するstate
    const [inputFile, setInputFile] = useState<File | null>()

    //  stateにファイルを設定する関数
    function setStateFile (File: File){
        setInputFile(File)
    }

    //  stateのファイルを削除する関数
    function deleteFile(){
        setInputFile(null);
    }

    //  エラーメッセージを保持するstate
    const[errorMsg, setErrorMsg] = useState<string[]>([]);
    

    useAsyncEffect(async () => {
        let id;
        //  対応会員番号を取得できた場合、パラメータに設定
        if(cookieSecAccId.secIdCookie != null){
            id = cookieSecAccId.secIdCookie;
            setParamId(id);
        }else{
            id = cookieAccId.idCookie;
            setParamId(id);
        }

        //  出席にする日付のリストを取得
        const select = await getSelectDate({
            paramId: id,
            rotaryCd: cookieRotaryCd.rotaryCookie
        });
        setSelectDate(select)

    },[])



    //  入力チェック
    const onClickRegister = async () => {
        //  入力値チェック
        const errMsg = (inputValidate(input, inputFile, selectDate))

        if(errMsg.length > 0){
            setErrorMsg(errMsg)
            window.scrollTo({
                top:0,
                behavior: "smooth",
            })
            return;     //  エラーがある場合は処理を中断
        }
        //  エラーがなければクリア
        setErrorMsg([]);
        

        //  登録処理
        //  添付ファイル登録
        //  props:  fileinfo, account_id
        let attachmentsId = await setAttachmentFile({
            fileinfo: inputFile,
            loginId: loginId,
            rotaryCd: cookieRotaryCd.rotaryCookie
        });

        //  YYYY年MM月DD日  →   YYYY/MM/DD
        const formatSelectedDate = input.selectedDate.replace('年', '/').replace('月', '/').replace('日', '')

        //  メークアップ登録
        const makeupId = await setMakeUp({
            loginId: loginId,
            attachmentsId: attachmentsId,
            selectedDate: formatSelectedDate,
            joinedDate: input.joinedDate,
            clubName: input.clubName,
            memo: input.memo,
            rotaryCd: cookieRotaryCd.rotaryCookie
        });

        //  イベント参加IDを取得    d_event_join.event_join_id
        const event_join_id = await getEventJoinId({
            paramId: paramId,
            selectedDate: formatSelectedDate,
            rotaryCd: cookieRotaryCd.rotaryCookie
        })

        //  イベント参加情報の更新
        const response = await setMakeUpId({
            loginId: loginId,
            makeupId: makeupId,
            eventJoinId: event_join_id,
            rotaryCd: cookieRotaryCd.rotaryCookie
        })
        

        if(response && response.status == 204){
            navigate("/mypage")
        }else{
            setErrorMsg(['予期せぬエラーが発生しました。']);
            window.scrollTo({
                top:0,
                behavior: "smooth",
            })
            return;     //  エラーがある場合は処理を中断
        }

    }
    
    
    return (
        <>
            <div className="l-wrapper sp-view is-modal">
		        <main className="l-contents">
                    <Header />               
                    <form>
                        <div className="l-default-content">
                            <div className="l-inner">
                                <div className="l-title">
                                    <h2 className="title-txt">メークアップ登録画面</h2>
                                </div>
                                {/* エラーメッセージエリア */}                                
                                {errorMsg.length > 0 &&
                                        <ErrorMessage
                                            message={errorMsg}
                                        />
                                }
                                
                                <div className="event-wrap">
                                    <div className="form-area">
                                        <div className="form-note">
                                            <i className="is-required"></i>…必須項目
                                        </div>

                                        <div className="form-set">
                                            <dl>
                                                <dt className="fsz-m1 fw-b"><i className="is-required"></i>出席にする日付</dt>
                                                <dd>
                                                <fieldset className="frm-slc-box">
                                                    <label className="frm-lb">
                                                    <select 
                                                        className="select-main size-s" 
                                                        name="guest-type"
                                                        value={input?.selectedDate}
                                                        onChange={e => {
                                                            setInput({
                                                                ...input,
                                                                selectedDate: e.target.value
                                                            })
                                                        }}>
                                                        <option value="NOT-SELECT">選択してください</option>
                                                            {selectDate.length !== 0 &&
                                                                selectDate.map( item => {
                                                                    return(
                                                                        <SelectDate 
                                                                            key={item.event_id}
                                                                            event_id={item.event_id}
                                                                            date={item.date}
                                                                            
                                                                        />
                                                                    )
                                                                })
                                                            }
                                                    </select>
                                                    </label>
                                                </fieldset>
                                                </dd>
                                            </dl>
                                        </div>

                                        <div className="form-set">
                                            <dl>
                                                <dt className="fsz-m1 fw-b"><i className="is-required"></i>参加した日付</dt>
                                                <dd>
                                                <fieldset className="frm-date-box">
                                                    <label className="frm-lb">
                                                    <input 
                                                        type="date" 
                                                        name="eventDate"
                                                        value={input?.joinedDate}
                                                        id="eventdate"
                                                        className="input-sub size-s"
                                                        onChange={e => {
                                                            setInput({
                                                                ...input,
                                                                joinedDate: e.target.value
                                                            })
                                                        }}   
                                                        />
                                                    </label>
                                                </fieldset>
                                                </dd>
                                            </dl>
                                        </div>

                                        <div className="form-set">
                                            <dl>
                                                <dt className="fsz-m1 fw-b"><i className="is-required"></i>参加したクラブ名</dt>
                                                <dd>
                                                <fieldset className="frm-tx-box">
                                                    <label className="frm-lb">
                                                    <input 
                                                        type="text"
                                                        name="eventName"
                                                        value={input?.clubName}
                                                        id="eventname" 
                                                        className="input-sub size-l"
                                                        onChange={e=>{
                                                            setInput({
                                                                ...input,
                                                                clubName: e.target.value
                                                            })
                                                        }}
                                                         />
                                                    </label>
                                                </fieldset>
                                                </dd>
                                            </dl>
                                        </div>

                                        <div className="form-set">   
                                            <dl>
                                                <dt className="fsz-m1 fw-b"><i className="is-required"></i>メークアップ証明書</dt>
                                                <dd id="attachment-area-js">     
                                                    <fieldset className="frm-file-box" id="attachment-area0">
                                                        <div className="frm-file-box form-attachment">

                                                            <FileUp 
                                                                setInputFile={setStateFile}
                                                                deleteFile={deleteFile}
                                                            />
                                                        </div>

                                                        <div className="frm-img">
                                                            <img alt="" id="figureImage" />
                                                        </div>
                                                    </fieldset>
                                                </dd>
                                            </dl>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-set">
                                    <dl>
                                        <dt className="fsz-m1 fw-b">その他備考</dt>
                                        <dd>
                                        <fieldset className="frm-tx-box">
                                            <label className="frm-lb">
                                            <textarea name="mailHeader" id="mailheader" className="input-main is-textarea" cols={60} rows={6}
                                                value={input?.memo}
                                                onChange={e=>{
                                                    setInput({
                                                        ...input,
                                                        memo: e.target.value
                                                    })
                                                }}
                                            ></textarea>
                                            </label>
                                        </fieldset>
                                        </dd>
                                    </dl>
                                </div>

                                <div className="btn-area flex-column col1">
                                    <button 
                                        type="button" className="btn-main btnsz-l"
                                        onClick={ () => {
                                            onClickRegister()
                                        }}
                                    >
                                        登録
                                    </button>
                                </div>
                                <div className="pos-l">
                                    <a href="/mypage" className="arr-l link-txt-bl">戻る</a>
                                </div>

                            </div>
                        </div>
                    </form>
                </main>
                <Footer />
            </div>
        </>
    );
}